var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      staticClass: "image__pinterestLink",
      attrs: { href: _vm.uri, target: "_blank", title: _vm.title },
    },
    [
      _vm._t("default", function () {
        return [
          _c("img", {
            attrs: {
              src: "/typo3conf/ext/template/Resources/Public/Media/Social-media/icon_pinterest_f_white.svg",
              width: "50",
              height: "50",
              alt: "pinterest logo",
            },
          }),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }